(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["playroots-share-bar"] && !Shopify.designMode) return;
  try {
    if (!window.__playrootsShareBound) {
    window.__playrootsShareBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-playroots-share]');
      if (!button) return;
      event.preventDefault();
      var title = button.getAttribute('data-share-title') || document.title;
      var url = button.getAttribute('data-share-url') || window.location.href;
      var label = button.querySelector('[data-share-label]');
      var restore = function (text) {
        if (label) label.textContent = text;
      };
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      var copied = function () {
        restore('Link copied');
        setTimeout(function () {
          restore('Share');
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied).catch(function () {
          window.prompt('Copy this link', url);
        });
        return;
      }
      window.prompt('Copy this link', url);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
